import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
// local imports
import PoolVehicleService from 'service/PoolVehicleService'
import { GearFuelTypeOptions } from 'types/PoolVehicleType'

export default function useGetPoolVehicleLocationList() {
  const { t } = useTranslation()
  const [data, updateData] = useState<any[]>()
  const [fuelTypes, setFuelTypes] = useState<GearFuelTypeOptions[]>([])
  const [gearTypes, setGearTypes] = useState<GearFuelTypeOptions[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  /* Service Call Functions */
  const getPoolVehicleLocations = () => PoolVehicleService.getPoolVehicleLocations()
  const getFuelOptions = () => PoolVehicleService.getVehicleFuelTypes()
  const getGearOptions = () => PoolVehicleService.getVehicleGearTypes()

  function fetchData() {
    setIsLoading(true)
    Promise.allSettled([getPoolVehicleLocations(), getFuelOptions(), getGearOptions()])
      .then(([locations, fuel, gear]) => {
        locations.status === 'fulfilled' ? updateData(locations.value.data) : setError(true)
        fuel.status === 'fulfilled' ? setFuelTypes(fuel.value.data) : setError(true)
        gear.status === 'fulfilled' ? setGearTypes(gear.value.data) : setError(true)
      })
      .catch((_err) => setError(true))
      .finally(() => setIsLoading(false))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchData(), [])

  const gearTypesOptions = [{ id: 0, name: t('most-used-words.all') }, ...gearTypes]

  return { data, fuelTypes, gearTypes: gearTypesOptions, isLoading, error }
}
